export default (url = '') =>
  window.location.origin + '/' + (url ? url : '')
